export const PERFORMANCE_DASHBOARD_FILTERS_KEY = 'performanceDashboardFilters';
export const NAVBAR_COLLAPSED_KEY = 'navbarCollapsed';

export const STORAGE_KEYS_TO_CLEAR_ON_ORG_SWITCH = [
  {
    key: PERFORMANCE_DASHBOARD_FILTERS_KEY,
    storage: sessionStorage,
  },
] as const;
